import SignInCustomerSFC from "./SignInCustomer.vue";
export type { ISignInCustomerEmits } from "./emits";
export type { ISignInCustomerProps } from "./props";
export const SignInCustomer = SignInCustomerSFC;
